export const HEADER_HEIGHT_CSS_VAR = '--header-height';
